
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    filterData: {
      type: Array,
      default: () => []
    },
    hasCreate: {
      type: Boolean,
      default: true
    }
  },
  emits: ['create', 'search'],
  setup(props, contex) {
    const { t } = useI18n()
    const handleFilter = () => {
      contex.emit('search')
    }
    const handleCreate = () => {
      contex.emit('create')
    }
    return {
      t,
      handleFilter,
      handleCreate
    }
  }
})

